import { __generator } from "tslib";
import { takeLatest } from 'redux-saga/effects';
import { updateMeasuredCookie } from './actions';
import { MeasuredCookie } from './MeasuredCookie';
function handleUpdateCookie(_a) {
    var cookieDim, cookieType, dims, size;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        if (!payload) {
            return [2 /*return*/];
        }
        cookieDim = payload.cookieDim, cookieType = payload.cookieType, dims = payload.dims;
        size = cookieDim === 'both'
            ? [dims.width, dims.height]
            : dims[cookieDim];
        MeasuredCookie.write(cookieType, size);
        return [2 /*return*/];
    });
}
export default function saga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(updateMeasuredCookie, handleUpdateCookie)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map